// src/data/publicationsData.js

const publications = [
  {
    id: 4,
    title: 'Prolongation de l’avis de recrutement : Spécialiste Humanitaire',
    description: 'Prolongation de l’avis de recrutement d’un(e) Spécialiste Humanitaire. Les candidatures peuvent être déposées jusqu’au lundi 9 novembre 2026 à 17h00.',
    date: '21 octobre 2026',
    year: '2026',
    image: '/images/avis-recrutement-specialiste-humanitaire-ponah.jpg',
    slug: 'avis-recrutement-specialiste-humanitaire-ponah-2026',
    link: '/publications/avis-recrutement-specialiste-humanitaire-ponah-2026',
    downloadUrl: '/documents/AvisderecrutementSpecialisteHumanitairePONAH.pdf'
  },
  {
    id: 5,
    title: 'Avis d’appel d’offres : fourniture de mobilier de bureau à Bamako',
    description: 'Avis d’appel d’offres pour la sélection d’une entreprise chargée de la fourniture de mobilier de bureau à Bamako pour les projets Karité, RESTART et les activités de la mission ENGIM au Mali.',
    date: '11 avril 2026',
    year: '2026',
    image: '/images/avis-appel-offres-mobilier-bureau-engim-mali-2026.jpg',
    slug: 'avis-appel-offres-mobilier-bureau-engim-mali-2026',
    link: '/publications/avis-appel-offres-mobilier-bureau-engim-mali-2026',
    downloadUrl: '/documents/avis-appel-offres-mobilier-bureau-engim-mali-2026.pdf'
  },
  {
    id: 1,
    title: 'Brochure de Présentation de la PONAH',
    description: 'Une vue d’ensemble de la Plateforme des ONG Humanitaires nationales.',
    date: 'Janvier 2024',
    image: '/images/publication1.jpg',
    slug: 'brochure-presentation-ponah-2024',
    link: '/publications/brochure-presentation-ponah-2024'
  },
  {
    id: 2,
    title: 'Stratégie de Localisation au Mali',
    description: 'Document de référence pour la mise en œuvre de la localisation humanitaire.',
    date: 'Mai 2024',
    image: '/images/publication2.jpg',
    slug: 'strategie-localisation-mali-2024',
    link: '/publications/strategie-localisation-mali-2024'
  },
  {
    id: 3,
    title: 'Rapport d’Activités Annuel 2024',
    description: 'Récapitulatif des missions, actions et partenariats de la PONAH.',
    date: 'Décembre 2024',
    image: '/images/publication3.jpg',
    slug: 'rapport-annuel-ponah-2024',
    link: '/publications/rapport-annuel-ponah-2024'
  }
];

export default publications;
